export const API_BASE_URL = process.env.REACT_APP_WEB_SERVICE_URL;

export const DOMAIN_HOST = process.env.REACT_APP_ENV;
